import { useRef, useEffect } from "react"

export const useChangeClassElement = (change, value) => {
  const ref = useRef(null)

  useEffect(() => {
    if (ref.current && change) {
      ref.current.classList.add(value)
      return
    }

    ref.current.classList.remove(value)
  }, [ref, change])

  return ref
}



// WEBPACK FOOTER //
// ./src/hooks/useChangeClassElement.js